export default {
    login : {
      isUserAuthenticated: false ,
      username : ""
    }
  };